module.exports = __webpack_public_path__ + "img/after2.55caf756.png";